export default function formatTimestamp(timestamp) {
  const date = new Date(timestamp * 1000).toLocaleDateString('ru-RU',{day: 'numeric', month: 'long', year: 'numeric',timeZone:'Europe/Moscow'}); // Преобразуем в миллисекунды
  const formattedDate = date.replace(' г.', '');
  return formattedDate;
}
